import React, { useRef } from 'react';
import paper from '../../assets/paper.png';
import pencil from '../../assets/pencil.png';
import trash from '../../assets/trash.png';
import printer from '../../assets/Printer.png';
import pdf from '../../assets/pdf.png';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';
import { purchaseService } from '../../services/purchase.service';
import { Grid } from '@mui/material';
import GeneralModal from '../../helpers/GeneralModal';
import { createModal } from 'react-modal-promise';
import { SetPurchaseReceiveListData } from '../../store/purchaseReceiveAtom';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import HistoryContent from './PurchaseReceiveHistory';
import { useReactToPrint } from 'react-to-print';
import LogicContext from '../../Context/LogicContext';
import { useContext } from 'react';
import PurchaseReceiveScroll from './PurchaseReceiveScroll';
import PurchaseReceiveContent from './PurchaseReceiveContent';
import { toLowercaseKeys } from '../../helpers/toLowerCaseKeys';

const PurchaseReceiveDetailsPage = () => {
  const [tabValue, setTabValue] = React.useState('1');
  const [selectedList, setSelectedList] = useState([]);
  const myPromiseModal = createModal(GeneralModal);
  const setPurchaseReceiveData = SetPurchaseReceiveListData();
  const logicContext = useContext(LogicContext);
  const { purchase_id } = useParams();
  const navigate = useNavigate();
  const [purchaseData, setPurchaseData] = useState({});
  const { pathname } = useLocation();
  var url = pathname.split('/');
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const mountRef = useRef(false);
  const componentRef = useRef();

  useEffect(() => {
    document.title = 'Purchase Receive Details';
    mountRef.current = true;
    purchaseService.getPurchaseReceiveDetails(purchase_id).then(response => {
      const serverData = toLowercaseKeys(response.data);
      if (mountRef.current && serverData !== undefined) {
        if (response?.data) {
          setPurchaseData(serverData);
        } else {
          setPurchaseData({});
        }
      }
    });

    return () => {
      mountRef.current = false;
    };
  }, [purchase_id]);


  const viewDetails = id => {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`);
  };

  function onSelection(list) {
    let tempList = list?.filter(item => item.checked === true);
    setSelectedList(tempList);
  }

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  function getPurchaseReceiveListApi() {
    purchaseService.getPurchaseReceiveList().then(response => {
      if (response?.data !== undefined) {
        setPurchaseReceiveData(response.data);
      }
    });
  }

  const deletePurchaseReceive = async () => {
    await myPromiseModal({
      title: 'confirm your Delete!',
      body: `Do you want to delete ${purchaseData?.purchase_receive_number} ?`,
      showInput: false,
      placeHolder: '',
    }).then(response => {
      if (response.decision === true) {
        let temp = '';
        purchaseData.purchase_receive_details?.map((item, i) => {
          temp += `<a> <item_id> ${item?.Item_Id} </item_id> </a>`;
        });

        let option = 4;
        let xml_string_refno = `<root> ${temp} </root>`;
        purchaseService
          .submitPurchaseReceive({
            Purchase_Receive_Ref_No: purchaseData?.purchase_receive_ref_no,
            Purchase_Order_Ref_No: purchaseData?.purchase_order_ref_no,
            xml_string_refno,
            option,
          })
          .then(res => {
            if (res?.data !== undefined) {
              const { message_text } = res.data[0];
              logicContext.showToast(message_text, 'success');
              navigate(-1);
              return getPurchaseReceiveListApi();
            }
          })
          .catch(err => {
            // logicContext.showToast('Error', 'error');
          });
      }
    });
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const customTabChange = id => {
    setTabValue(id);
  };

  function viewBillDetails(bill_id) {
    navigate(`/${currModuleId}/${currModuleName}/${'bills'}/details/${bill_id}`);
  }

  return (
    <>
      <section className="mt-2">
        <Grid container className="" spacing={2}>
          <Grid item xs={12}>
            <section className="max-auto max-w-6xl">
              <div className="flex flex-wrap justify-between md: md:"></div>
            </section>
          </Grid>

          <Grid item xs={12}>
            <section className="">
              <Grid container className="" spacing={0}>
                <Grid className="no-print" item xs={2.8}>
                  <PurchaseReceiveScroll viewDetails={viewDetails} onSelection={onSelection} />
                </Grid>
                <Grid item xs={9.2}>
                  <section className="w-full b z-50">
                    <div className="flex justify-end no-print">
                      <div className="flex">
                        <button style={{ borderRadius: '5px' }} className="px-3 h-[6vh] text-filterTextColor bg-filterColor lg:pt-1 mr-3">
                          <img src={paper} alt="" className="" />
                        </button>
                        <button
                          onClick={() => handlePrint()}
                          style={{ borderRadius: '5px' }}
                          className="px-3 h-[6vh] text-filterTextColor bg-filterColor lg:pt-1 mr-3"
                        >
                          <img src={pdf} alt="" className="" />
                        </button>
                        <button
                          onClick={() => handlePrint()}
                          style={{ borderRadius: '5px' }}
                          className="px-3 h-[6vh] text-filterTextColor bg-filterColor lg:pt-1 mr-3"
                        >
                          <img src={printer} alt="" className="" />
                        </button>
                        <button
                          onClick={deletePurchaseReceive}
                          style={{ borderRadius: '5px' }}
                          className="px-3 h-[6vh] text-filterTextColor bg-filterColor lg:pt-1 ml-2"
                        >
                          <img src={trash} alt="" />
                        </button>
                      </div>
                    </div>

                    <section className="border-2 mx-2 mt-3">
                      <Box sx={{ width: '100%', typography: 'body1' }}>
                        <TabContext value={tabValue}>
                          <Box className="ml-4 mt-2 no-print" sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                              <Tab label="Details" value="1" />
                              {purchaseData?.count_information?.length > 0 && (
                                <Tab label={`Comments & History (` + purchaseData?.count_information[0]?.history_count + ')'} value="2" />
                              )}
                              {purchaseData?.count_information?.length > 0 && (
                                <Tab label={`Payment (` + purchaseData?.count_information[0]?.payment_count + ')'} value="3" />
                              )}
                            </TabList>
                          </Box>

                          <TabPanel value="1">
                            <PurchaseReceiveContent
                              ref={componentRef}
                              purchaseData={purchaseData}
                              viewBillDetails={viewBillDetails}
                              customTabChange={customTabChange}
                            />
                          </TabPanel>

                          <TabPanel value="2">
                            <HistoryContent />
                          </TabPanel>

                          <TabPanel value="3"></TabPanel>
                        </TabContext>
                      </Box>
                    </section>
                  </section>
                </Grid>
              </Grid>
            </section>
          </Grid>
        </Grid>
      </section>
    </>
  );
};

export default PurchaseReceiveDetailsPage;
